import "./Global.css";
import RoutesApp from "./routes/Route";
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
    return (
        <>
            <RoutesApp />
        </>
    );
};

export default App;